import { store } from "../../appRedux/store/Store";

// Language/localization headers for legacy API calls
export const localizationInterceptor = {
   request: (config) => {
      // Add language headers for legacy GET requests
      if (config?.url?.includes("legacy") && config?.data?.httpMethod === "GET") {
         const lang = store?.getState()?.settings?.locale;
         if (lang) {
            const params = config.data.parameters;
            if (params) {
               if (params.charAt(0) === "/") {
                  // URL params format
                  const newParameters = JSON.parse(params.substring(1, params.length));
                  newParameters.lang = lang;
                  config.data.parameters = `/${JSON.stringify(newParameters)}`;
               } else {
                  // Standard params format
                  const newParameters = JSON.parse(params);
                  newParameters.lang = lang;
                  config.data.parameters = JSON.stringify(newParameters);
               }
            }

            config.data.headers = {
               ...config.data.headers,
               "X-LANG": `${lang}`,
               "Content-Language": `${lang}`,
            };
         }
      }
      return config;
   },
};
